//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var ProductsCarousel = () => import('~/components/organisms/Global/ProductsCarousel.vue');

var PendingTag = () => import('~/components/functional/TcVars/PendingTag.vue');

export default {
  name: 'CrossEarlyBirds',
  components: {
    ProductsCarousel,
    PendingTag
  },
  props: {
    products: {
      type: Array,
      default: null
    },
    reference: {
      type: String,
      default: null
    },
    blockType: {
      type: String,
      default: 'similar'
    }
  },
  computed: {
    displayTracking() {
      return typeof window !== 'undefined' ? {
        data: {
          event_category: 'FicheProduit',
          event_action: this.blockType === 'similar' ? 'Display_Xsell_EB' : 'Display_Xsell_EB_complementary',
          event_label: "".concat(window.tc_vars.page_cat3, "_").concat(this.reference),
          event_is_non_interactive: 1
        }
      } : {};
    },

    title() {
      return this.$t(this.blockType);
    }

  }
};